{
  "generating": "Generar",
  "reviewTrades": "Revisar operaciones",
  "updateTrades": "Actualizar operaciones completadas",
  "completed": "Completado",
  "generatingDescription": "Se están generando operaciones ahora mismo...",
  "rebalanceOn": "Reequilibrar en",
  "rebalanceCanceled": "El reequilibrio se ha cancelado, regrese para iniciar uno nuevo.",
  "buyTradeFile": "Descargar archivo de compra comercial",
  "sellTradeFile": "Descargar archivo de venta comercial",
  "mutualFundTradeFile": "Descargar archivo de operaciones con fondos de inversión",
  "ptfBulkTradeFile": "Descarga del archivo comercial por lotes PTF",
  "tradeViaFix": "Operaciones a través de FIX",
  "bulkBUYTrades": "Operaciones de compras por lotes",
  "bulkSELLTrades": "Operaciones de ventas por lotes",
  "cancelRebalanceTrades": "Cancelar operaciones de reequilibrio",
  "rebalanceCompleted": "Reequilibrio completado",
  "allPricesNotUpdated": "Todos los precios aún no están actualizados",
  "pasteFromExcel": "Copiar/Pegar desde Excel",
  "orderOfContent": "Asegúrese de que las columnas estén ordenadas por ticker, precio y cantidad",
  "cancelConfirmationDialog": "Antes de cancelar, asegúrese de que no ha enviado los archivos de operaciones por lotes. Si ya envió los archivos de operaciones por lotes, el sistema mostrará un ERROR, ya que todas esas operaciones se han enviado al administrador.",
  "cancelTriggeredMessage": "¡Se activó la cancelación de las operaciones de reequilibrio!",
  "discrepancyConfirmationDialog": {
    "title": "Discrepancias en transacciones por lotes",
    "text": "Existen discrepancias relevantes en las cantidades asignadas o en los precios. ¿Está seguro de que desea continuar?"
  },
  "orderOfPortfolioContent": "Asegúrese de que las columnas estén ordenadas por ticker y porcentaje",
  "generate": "Generar"
}
